import React, { Component } from 'react'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import PasswordUpdateUI from './PasswordUpdateUI.js'

class PasswordUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false,
      oldPassword: '',
      newPassword: '',
      reenterPassword: '',
      oldPasswordError: null,
      newPasswordError: null,
      reenterPasswordError: null
    }
  }

  render() {
    return (
      <PasswordUpdateUI
        context={this.props.context}
        // text
        messageList={this.props.messageList}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        // state
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancel={this.props.onCancel} // added in ViewOrUpdateUI
        setErrorList={this.setErrorList}
        // old password
        oldPassword={this.state.oldPassword}
        oldPasswordError={this.state.oldPasswordError}
        onOldPasswordChange={this.onOldPasswordChange}
        setOldPasswordError={this.setOldPasswordError}
        // new password
        newPassword={this.state.newPassword}
        newPasswordError={this.state.newPasswordError}
        onNewPasswordChange={this.onNewPasswordChange}
        setNewPasswordError={this.setNewPasswordError}
        // reenter password
        reenterPassword={this.state.reenterPassword}
        reenterPasswordError={this.state.reenterPasswordError}
        onReenterPasswordChange={this.onReenterPasswordChange}
        setReenterPasswordError={this.setReenterPasswordError}
      />
    )
  }

  UNSAFE_componentWillMount() {
  }

  onOldPasswordChange = (event) => {
    this.setState({oldPassword: event.target.value})
  }

  setOldPasswordError = (error) => {
    this.setState({oldPasswordError: error})
  }

  onNewPasswordChange = (event) => {
    this.setState({newPassword: event.target.value})
  }

  setNewPasswordError = (error) => {
    this.setState({newPasswordError: error})
  }

  onReenterPasswordChange = (event) => {
    this.setState({reenterPassword: event.target.value})
  }

  setReenterPasswordError = (error) => {
    this.setState({reenterPasswordError: error})
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    console.log('calling server')
    this.setState({submitted: true})
    RestApiUtils.put(this.props.context,
      '/api/user/password',
      this.onSubmitCallback, {
        oldPassword: this.state.oldPassword,
        newPassword: this.state.newPassword,
        reenterPassword: this.state.reenterPassword
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'oldPassword':
            this.setOldPasswordError(error.message)
            break;
          case 'newPassword':
            this.setNewPasswordError(error.message)
            break;
          case 'reenterPassword':
            this.setReenterPasswordError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({successMsg: response.success})

    if (errorList.length === 0) {
      setTimeout(() => {
        this.props.onCancel()
      }, 2000);
    }
  }
}

export default PasswordUpdateSF
